import { api, selecionarGestor as selecionarGestorNoClient } from '@/api/turbopro';
import type { BuscaGestorResponse } from '@/services/Auth/types';

/** Mesma rota que o TurboPro já chamava antes da migração — só troca de client. */
export async function buscarGestoresDoUsuario(email: string): Promise<BuscaGestorResponse> {
  const emailBase64 = btoa(email);
  return api.get<BuscaGestorResponse>(`gestorusuario/BuscaGestorByEmail?EmailLogin=${emailBase64}`);
}

/** Valida o vínculo no backend e reemite o JWT já com `cnpj_gestor` embutido. */
export async function vincularSessaoAoGestor(cnpjGestor: string) {
  return selecionarGestorNoClient(cnpjGestor);
}
